var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsDate, IsUUID } from 'class-validator';
/**
 * An appointment of the Verordnung that is already booked, sent with
 * {@link FindEarliestSlotsRequestDto.bookedPlanSlots} (#1937). It counts
 * towards its treatment's week of the weekly frequency, so planning the rest of
 * a half-booked Verordnung does not over-book a week. Nothing else: its time is
 * already busy (the office's appointments), and it is already left out of the
 * constraint's `appointmentCount` (only open units are searched).
 */
export class BookedPlanSlotDto {
    treatmentId;
    start;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], BookedPlanSlotDto.prototype, "treatmentId", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], BookedPlanSlotDto.prototype, "start", void 0);
//# sourceMappingURL=booked-plan-slot.dto.js.map